import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {
  atomButtonAlignment,
  atomButtonDesigns,
  atomButtonShapes,
  atomButtonSizes
} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import IconBinOutline from '@adv-mt/mt-svg-icons/lib/BinOutline.js'

export const TYPES = {
  ACTION_BUTTON: 'actionButton',
  ICON: 'icon',
  ICON_BUTTON: 'iconButton',
  ICON_BUTTON_NEGATIVE: 'iconButtonNegative',
  INLINE_BUTTON: 'inlineButton',
  MENU_BUTTON: 'menuButton'
}

const BASE_CLASS = 'mt-ActionsAdFavorite'

const NO_OP = () => {}

const IconType = ({onClick}) => {
  return (
    <div className={BASE_CLASS} onClick={onClick}>
      <IconBinOutline size="medium" />
    </div>
  )
}

IconType.propTypes = {
  onClick: PropTypes.function
}

const IconButtonType = ({onClick, size, negative}) => {
  const {i18n} = useContext(Context)

  return (
    <AtomButton
      shape={atomButtonShapes.CIRCULAR}
      design={atomButtonDesigns.FLAT}
      leftIcon={<IconBinOutline />}
      onClick={onClick}
      size={size}
      negative={negative}
      aria-label={i18n.t('CARD_AD_DISCARD')}
    />
  )
}

IconButtonType.propTypes = {
  onClick: PropTypes.function,
  size: PropTypes.oneOf(Object.values(atomButtonSizes)),
  negative: PropTypes.bool
}

const IconLabelButtonType = ({onClick, size}) => {
  const {i18n} = useContext(Context)

  return (
    <AtomButton
      alignement={atomButtonAlignment.LEFT}
      shape={atomButtonShapes.CIRCULAR}
      design={atomButtonDesigns.FLAT}
      leftIcon={<IconBinOutline />}
      onClick={onClick}
      size={size}
    >
      {i18n.t('CARD_AD_DISCARD')}
    </AtomButton>
  )
}

IconLabelButtonType.propTypes = {
  onClick: PropTypes.function,
  size: PropTypes.oneOf(Object.values(atomButtonSizes))
}

const IconLabelStackedButtonType = ({onClick, size}) => {
  const {i18n} = useContext(Context)

  return (
    <AtomButton
      alignement={atomButtonAlignment.LEFT}
      fullWidth
      shape={atomButtonShapes.CIRCULAR}
      design={atomButtonDesigns.FLAT}
      leftIcon={<IconBinOutline />}
      onClick={onClick}
      size={size}
    >
      {i18n.t('CARD_AD_DISCARD')}
    </AtomButton>
  )
}

IconLabelStackedButtonType.propTypes = {
  onClick: PropTypes.function,
  size: PropTypes.oneOf(Object.values(atomButtonSizes))
}

const ActionsAdDiscardButton = ({size = atomButtonSizes.MEDIUM, type = TYPES.ICON, onClick = NO_OP}) => {
  switch (type) {
    case TYPES.ICON:
      return <IconType onClick={onClick} />
    case TYPES.ICON_BUTTON:
      return <IconButtonType onClick={onClick} size={size} />
    case TYPES.ICON_BUTTON_NEGATIVE:
      return <IconButtonType onClick={onClick} size={size} negative />
    case TYPES.INLINE_BUTTON:
      return <IconLabelButtonType onClick={onClick} size={size} />
    case TYPES.MENU_BUTTON:
      return <IconLabelStackedButtonType onClick={onClick} size={size} />
    default:
      return <IconType onClick={onClick} />
  }
}

ActionsAdDiscardButton.displayName = 'ActionsAdDiscardButton'
ActionsAdDiscardButton.propTypes = {
  onClick: PropTypes.function,
  size: PropTypes.oneOf(Object.values(atomButtonSizes)),
  type: PropTypes.oneOf(Object.values(TYPES))
}

export default ActionsAdDiscardButton
